const surveyLinkStyles = (theme) => ({
  color: theme.palette.primary.main,
  textDecorationColor: theme.palette.primary.main,
  "&:hover": {
    color: theme.palette.tertiary.main,
    textDecorationColor: theme.palette.tertiary.main,
  },
  ":focus": {
    outline: `1px dashed ${theme.palette.tertiary.main}`,
    color: theme.palette.tertiary.main,
    textDecorationColor: theme.palette.tertiary.main,
    outlineOffset: 1,
  },
});

export default surveyLinkStyles;
